import SEOHead from '@/components/SEOHead';
import DownloadHeroV2 from '@/components/marketing/download/v2/DownloadHeroV2';
import DownloadPlatformsV2 from '@/components/marketing/download/v2/DownloadPlatformsV2';
import DownloadMatrixV2 from '@/components/marketing/download/v2/DownloadMatrixV2';
import DownloadUseCasesV2 from '@/components/marketing/download/v2/DownloadUseCasesV2';
import DownloadRequirementsV2 from '@/components/marketing/download/v2/DownloadRequirementsV2';
import { FinalCtaSection } from '@/components/marketing/v2/FinalCtaSection';

// Version la plus récente parmi desktop/mobile/web (surface SEO + JSON-LD).
const LATEST_VERSION = '0.4.53';

export default function Download() {
  return (
    <>
      <SEOHead
        title="Télécharger — Velko POS pour Windows, macOS, Linux, Android"
        description={`Télécharge Velko POS sur Web, Desktop (Windows, macOS, Linux) ou Android. Version ${LATEST_VERSION}, open-source et publiée sur GitHub Releases. Guide d'installation fourni pour chaque système. Sync automatique entre appareils.`}
        path="/telechargement"
        ogImage="/brand/og/og-download.png"
        breadcrumbs={[
          { name: 'Accueil', path: '/' },
          { name: 'Téléchargement', path: '/telechargement' },
        ]}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          name: 'Velko POS',
          operatingSystem: 'Web, Windows, macOS, Linux, Android',
          applicationCategory: 'BusinessApplication',
          downloadUrl: 'https://velko-pos.com/telechargement',
          softwareVersion: LATEST_VERSION,
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'XOF',
          },
        }}
      />

      <DownloadHeroV2 />
      <DownloadPlatformsV2 />
      <DownloadMatrixV2 />
      <DownloadUseCasesV2 />
      <DownloadRequirementsV2 />
      <FinalCtaSection
        eyebrow="Prêt à l'essayer ?"
        title="Crée ton compte."
        highlight="Télécharge après."
        subtitle="Tu peux démarrer sur le Web sans rien installer, tester gratuitement, puis installer l'app Desktop ou Mobile quand tu veux. Même compte, tout synchronisé."
        primaryLabel="Créer un compte gratuit"
        primaryTo="/register"
        secondaryLabel="Guide d'installation"
        secondaryTo="/guide-installation"
        guarantees={[
          'Plan gratuit permanent',
          'Sans carte bancaire',
          'Sync temps réel',
          'Open-source vérifiable',
        ]}
      />
    </>
  );
}
